<template>
  <div class="menu-management-container">
    <div class="card">
      <h1>菜单管理</h1>
      <button class="btn btn-primary" @click="showAddMenuDialog = true">添加菜单</button>
      <div class="custom-table-wrapper">
        <table class="custom-table" style="width: 100%">
          <thead>
            <tr>
              <th>菜单名称</th>
              <th>路径</th>
              <th>父菜单ID</th>
              <th style="width: 200px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="menu in menus" :key="menu.id">
              <td>{{ menu.name }}</td>
              <td>{{ menu.path }}</td>
              <td>{{ menu.parent_id || '-' }}</td>
              <td>
                <button class="btn btn-primary btn-small" @click="editMenu(menu)">编辑</button>
                <button class="btn btn-danger btn-small" @click="deleteMenu(menu.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 添加菜单弹窗 -->
      <Transition name="dialog">
        <div v-if="showAddMenuDialog" class="dialog-overlay" @click.self="showAddMenuDialog = false">
          <div class="dialog" style="width: 30%">
            <div class="dialog-header">
              <h3 class="dialog-title">添加菜单</h3>
              <button class="dialog-close" @click="showAddMenuDialog = false">&times;</button>
            </div>
            <div class="dialog-body">
              <form ref="addMenuForm" @submit.prevent="submitAddMenu" class="form">
                <div class="form-group">
                  <label class="form-label">菜单名称</label>
                  <input 
                    v-model="newMenu.name" 
                    class="form-input"
                    :class="{ 'error': errors.name }"
                    type="text"
                    required
                    placeholder="请输入菜单名称"
                  />
                  <div v-if="errors.name" class="error-message">{{ errors.name }}</div>
                </div>
                <div class="form-group">
                  <label class="form-label">路径</label>
                  <input 
                    v-model="newMenu.path" 
                    class="form-input"
                    :class="{ 'error': errors.path }"
                    type="text"
                    required
                    placeholder="请输入路径"
                  />
                  <div v-if="errors.path" class="error-message">{{ errors.path }}</div>
                </div>
                <div class="form-group">
                  <label class="form-label">排序</label>
                  <input 
                    v-model="newMenu.sort" 
                    class="form-input"
                    type="number"
                    min="0"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">状态</label>
                  <label class="switch">
                    <input 
                      type="checkbox" 
                      v-model="newMenu.status"
                    />
                    <span class="slider"></span>
                  </label>
                  <span class="switch-label">{{ newMenu.status ? '启用' : '禁用' }}</span>
                </div>
              </form>
            </div>
            <div class="dialog-footer">
              <button class="btn" @click="showAddMenuDialog = false">取消</button>
              <button class="btn btn-primary" @click="submitAddMenu">保存</button>
            </div>
          </div>
        </div>
      </Transition>

      <!-- 编辑菜单弹窗 -->
      <Transition name="dialog">
        <div v-if="showEditMenuDialog" class="dialog-overlay" @click.self="showEditMenuDialog = false">
          <div class="dialog" style="width: 30%">
            <div class="dialog-header">
              <h3 class="dialog-title">编辑菜单</h3>
              <button class="dialog-close" @click="showEditMenuDialog = false">&times;</button>
            </div>
            <div class="dialog-body">
              <form @submit.prevent="submitEditMenu" class="form">
                <div class="form-group">
                  <label class="form-label">菜单名称</label>
                  <input 
                    v-model="editingMenu.name" 
                    class="form-input"
                    type="text"
                    required
                    placeholder="请输入菜单名称"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">路径</label>
                  <input 
                    v-model="editingMenu.path" 
                    class="form-input"
                    type="text"
                    required
                    placeholder="请输入路径"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">排序</label>
                  <input 
                    v-model="editingMenu.sort" 
                    class="form-input"
                    type="number"
                    min="0"
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">状态</label>
                  <label class="switch">
                    <input 
                      type="checkbox" 
                      v-model="editingMenu.status"
                    />
                    <span class="slider"></span>
                  </label>
                  <span class="switch-label">{{ editingMenu.status ? '启用' : '禁用' }}</span>
                </div>
              </form>
            </div>
            <div class="dialog-footer">
              <button class="btn" @click="showEditMenuDialog = false">取消</button>
              <button class="btn btn-primary" @click="submitEditMenu">保存</button>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      menus: [],
      newMenu: { name: '', path: '', sort: 0, status: false },
      editingMenu: {},
      showAddMenuDialog: false,
      showEditMenuDialog: false,
      errors: {},
      rules: {
        name: {
          required: true,
          message: '请输入菜单名称'
        },
        path: {
          required: true,
          message: '请输入路径'
        }
      }
    };
  },
  created() {
    this.fetchMenus();
  },
  methods: {
    async fetchMenus() {
      const res = await axios.get('/api/menus');
      this.menus = res.data.map(menu => ({
        ...menu,
        status: Boolean(menu.status)  // 确保 status 是布尔值
      }));
    },
    // 验证表单
    validateForm(formData, rules) {
      let isValid = true;
      this.errors = {};
      
      for (const field in rules) {
        const rule = rules[field];
        if (rule.required && (!formData[field] || formData[field].toString().trim() === '')) {
          this.errors[field] = rule.message;
          isValid = false;
        }
      }
      
      return isValid;
    },
    
    // 显示消息
    showMessage(message, type = 'success') {
      const toast = document.createElement('div');
      toast.className = `message-toast message-toast-${type}`;
      toast.textContent = message;
      document.body.appendChild(toast);
      
      // 自动关闭
      setTimeout(() => {
        toast.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => {
          document.body.removeChild(toast);
        }, 300);
      }, 3000);
    },
    
    async submitAddMenu() {
      try {
        if (this.validateForm(this.newMenu, this.rules)) {
          await axios.post('/api/menus', this.newMenu);
          this.showAddMenuDialog = false;
          this.fetchMenus();
          this.showMessage('菜单添加成功');
          // 重置表单
          this.newMenu = { name: '', path: '', sort: 0, status: false };
        }
      } catch (error) {
        this.showMessage(error.response?.data?.detail || '添加失败', 'error');
        console.error('添加菜单失败:', error);
      }
    },
    editMenu(menu) {
      // 将 status 字段从数字转换为布尔值
      this.editingMenu = {
        ...menu,
        status: Boolean(menu.status)  // 确保 status 是布尔值
      };
      this.showEditMenuDialog = true;
    },
    async submitEditMenu() {
      try {
        if (this.editingMenu.name && this.editingMenu.path) {
          await axios.put(`/api/menus/${this.editingMenu.id}`, this.editingMenu);
          this.showEditMenuDialog = false;
          this.fetchMenus();
          this.showMessage('菜单编辑成功');
        } else {
          this.showMessage('请填写必填字段', 'error');
        }
      } catch (error) {
        this.showMessage(error.response?.data?.detail || '编辑失败', 'error');
        console.error('编辑菜单失败:', error);
      }
    },
    async deleteMenu(id) {
      if (confirm('确定要删除这个菜单吗？')) {
        try {
          await axios.delete(`/api/menus/${id}`);
          this.fetchMenus();
          this.showMessage('菜单删除成功');
        } catch (error) {
          this.showMessage('删除菜单失败', 'error');
          console.error('删除菜单失败:', error);
        }
      }
    }
  }
};
</script>

<style scoped>
/* 容器样式 */
.menu-management-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* 卡片样式 */
.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 24px;
}

/* 按钮样式 */
.btn {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: white;
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  margin-right: 8px;
  margin-top: 10px;
}

.btn:hover {
  border-color: #c6e2ff;
  color: #409eff;
}

.btn-primary {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
}

.btn-primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.btn-danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: white;
}

.btn-danger:hover {
  background-color: #f78989;
  border-color: #f78989;
}

.btn-small {
  padding: 4px 12px;
  font-size: 12px;
  margin-right: 5px;
}

/* 表格样式 */
.custom-table-wrapper {
  margin-top: 20px;
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.custom-table th,
.custom-table td {
  padding: 12px 16px;
  border: 1px solid #ebeef5;
  text-align: left;
}

.custom-table th {
  background-color: #f0f2f5;
  color: #333;
  font-weight: 600;
}

.custom-table tr:hover {
  background-color: #f5f7fa;
}

/* 对话框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 500px;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

.dialog-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #909399;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-close:hover {
  color: #606266;
}

.dialog-body {
  padding: 20px;
}

.dialog-footer {
  padding: 20px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 表单样式 */
.form {
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  width: 100px;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.form-input.error {
  border-color: #f56c6c;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}

/* 开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-right: 8px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #409eff;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.switch-label {
  font-size: 14px;
  color: #606266;
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: white;
  z-index: 9999;
  animation: slideIn 0.3s ease;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.message-toast-success {
  background-color: #67c23a;
}

.message-toast-error {
  background-color: #f56c6c;
}

/* 动画效果 */
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

/* 对话框过渡效果 */
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .dialog,
.dialog-leave-active .dialog {
  transition: transform 0.3s ease;
}

.dialog-enter-from .dialog {
  transform: translateY(-50px);
}

.dialog-leave-to .dialog {
  transform: translateY(-50px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .menu-management-container {
    padding: 10px;
  }
  
  .card {
    padding: 16px;
  }
  
  .dialog {
    width: 95%;
    margin: 20px;
  }
  
  .custom-table th,
  .custom-table td {
    padding: 8px 12px;
    font-size: 12px;
  }
}
</style>
